<template>
  <div class="thread-child-replies">
    <button
      v-if="replies && replies.length"
      class="thread-child-replies__toggle-all text-button"
      :class="{ 'thread-child-replies__toggle-all--is-open': showReplies }"
      @click="handleToggleAll"
    >
      <span v-if="!showReplies" class="thread-child-replies__toggle-text">Show {{ replies.length }} replies</span>
      <span v-else class="visually-hidden">Hide Replies</span>
    </button>
    <template v-if="showReplies">
      <button
        v-if="showTruncatedReplies"
        class="thread-child-replies__toggle text-button"
        :aria-expanded="isOpened ? 'true' : 'false'"
        aria-controls="thread-child-replies-replies"
        @click="showPreviousReplies()"
      >
        {{ viewRepliesButtonText }}
        <icon-component
          name="caret"
          title="caret icon"
          class="thread-child-replies__icon icon--small"
        />
      </button>
      <ol
        v-if="showTruncatedReplies"
        id="thread-child-replies-replies"
        class="thread-child-replies__replies"
      >
        <li
          v-for="reply in mostRecentReplies"
          :key="reply.id"
          class="thread-child-replies__reply"
        >
          <thread-reply
            :reply="reply"
            :thread="thread"
          />
        </li>
      </ol>
      <ol
        v-else
        id="thread-child-replies-replies"
        class="thread-child-replies__replies"
      >
        <li
          v-for="reply in replies"
          :key="reply.id"
          class="thread-child-replies__reply"
        >
          <thread-reply
            :reply="reply"
            :thread="thread"
          />
        </li>
      </ol>
    </template>
  </div>
</template>

<script>
import scrollToMixin from '@/mixins/scroll-to-mixin';

export default {
  name: 'ThreadChildReplies',
  components: {
    ThreadReply: () => import('@/components/Thread/ThreadReply.vue'),
  },
  mixins: [scrollToMixin],
  props: {
    replies: {
      type: Array,
      required: true,
    },
    parentReplyId: {
      type: String,
      required: true,
    },
    thread: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostRecentReplies: [],
      isOpened: false,
      recentLimit: 2,
      showReplies: true,
    };
  },
  computed: {
    showTruncatedReplies() {
      return this.replies.length > this.recentLimit && !this.isOpened;
    },
    viewRepliesButtonText() {
      return `View ${this.replies.length - this.mostRecentReplies.length} previous replies`;
    },
  },
  created() {
    if (this.replies.length > this.recentLimit) {
      this.mostRecentReplies = this.replies.slice(
        this.replies.length - this.recentLimit,
        this.replies.length,
      );
    }
  },
  methods: {
    showPreviousReplies() {
      this.isOpened = true;
    },
    handleToggleAll() {
      this.showReplies = !this.showReplies;

      if (!this.showReplies) this.scrollTo(`#reply-${this.parentReplyId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_thread-child-replies';
</style>

<docs>
A list of replies which belong to thread reply.
If there are more than 2 replies, it is truncated
and will show a CTA to show previous replies after
the most recent two

</docs>
